
import axios from '../config/axios';

export const url = '/api/citas3jr0x'


export const createcitas3jr0x = ({
  token,
	ciudaddm0a3,
	fechaqo88o,
	nombrecompletohd3lm,
	telefonoidihyi,
	emailnapbb,
	horareunionbz2wp,
	tipovehiculomvnwp,
	experienciauberxo2aj,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token ) {

    axios.post(`${url}//create/basic/68fa621be3072492500689f7`, {
		ciudaddm0a3,
		fechaqo88o,
		nombrecompletohd3lm,
		telefonoidihyi,
		emailnapbb,
		horareunionbz2wp,
		tipovehiculomvnwp,
		experienciauberxo2aj,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

